import { QueryClient } from "@tanstack/react-query";

/**
 * TanStack Query 默认配置:
 * - staleTime 60s: GET 接口缓存 1 分钟内不重发 (解决 cost.html 频繁切 tab 闪烁)
 * - retry 1: 失败重试一次 (API 错误不重试)
 * - refetchOnWindowFocus false: 切回标签页不自动 refetch (避免无意义重拉)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
